var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendrier(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 87,
    viewBox: "0 0 88 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6289",
    "data-name": "Groupe 6289",
    transform: "translate(0.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    transform: "translate(-0.176 0)",
    fill: "#f4deff",
    stroke: "#956ae1",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 44,
    cy: 43.5,
    rx: 44,
    ry: 43.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 44,
    cy: 43.5,
    rx: 43.5,
    ry: 43,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_600",
    "data-name": "Groupe 600",
    transform: "translate(24.149 24.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_753",
    "data-name": "Trac\\xE9 753",
    d: "M34.256,2.37a3.426,3.426,0,0,0-6.49-.085H22.727a3.426,3.426,0,0,0-6.461,0H11.227a3.426,3.426,0,0,0-6.49.085A5.72,5.72,0,0,0,0,8V35.566a3.431,3.431,0,0,0,3.427,3.427H35.566a3.431,3.431,0,0,0,3.427-3.427V8A5.72,5.72,0,0,0,34.256,2.37M31,2.285a1.144,1.144,0,0,1,1.142,1.142V5.712a1.142,1.142,0,0,1-2.285,0V3.427A1.144,1.144,0,0,1,31,2.285m-11.5,0a1.144,1.144,0,0,1,1.142,1.142V5.712a1.142,1.142,0,1,1-2.285,0V3.427A1.144,1.144,0,0,1,19.5,2.285M8,2.285A1.144,1.144,0,0,1,9.139,3.427V5.712a1.142,1.142,0,1,1-2.285,0V3.427A1.144,1.144,0,0,1,8,2.285M2.285,8A3.432,3.432,0,0,1,4.569,4.766v.946a3.427,3.427,0,1,0,6.854,0V4.569h4.646V5.712a3.427,3.427,0,1,0,6.854,0V4.569h4.646V5.712a3.427,3.427,0,0,0,6.854,0V4.766A3.432,3.432,0,0,1,36.708,8v3.5H2.285ZM36.708,35.566a1.144,1.144,0,0,1-1.142,1.142H3.427a1.144,1.144,0,0,1-1.142-1.142V13.785H36.708Z",
    transform: "translate(0 0)",
    fill: "#956ae1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_754",
    "data-name": "Trac\\xE9 754",
    d: "M125.569,252.424a2.287,2.287,0,0,1-2.285-2.285,1.142,1.142,0,1,0-2.285,0,4.569,4.569,0,1,0,5.967-4.351l2.838-2.838A1.144,1.144,0,0,0,129,241h-6.854a1.142,1.142,0,0,0,0,2.285h4.1l-2.619,2.619a1.143,1.143,0,0,0,.808,1.95h1.142a2.285,2.285,0,1,1,0,4.569",
    transform: "translate(-111.784 -222.646)",
    fill: "#956ae1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_755",
    "data-name": "Trac\\xE9 755",
    d: "M272.142,252.41a1.142,1.142,0,0,0,0,2.285h9.139a1.142,1.142,0,1,0,0-2.285h-3.427V242.129a1.144,1.144,0,0,0-1.95-.808l-4.569,4.569a1.142,1.142,0,1,0,1.616,1.616l2.619-2.619v7.523Z",
    transform: "translate(-250.36 -222.632)",
    fill: "#956ae1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendrier);
export default __webpack_public_path__ + "static/media/calendrier.729586e2cffdb7514199d7a99bb0fa43.svg";
export { ForwardRef as ReactComponent };